import { Injectable } from '@angular/core';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GenericPaymentFormService extends BaseProvider {
	feeAmount: any = 0;
	amountToPay: any = 0;

	payEvent = new Subject();

	constructor() { 
		super();
		
		this.baseUrl = "payment";		
	}		
}
